import { BeneficiaryFilterAllTypes } from '@repo/shared/dtos/beneficiary'
import { StructuredDataSchemaItem } from '@repo/shared/dtos/structured-data'
import { Button } from '@repo/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@repo/ui/popover'
import { XIcon } from 'lucide-react'
import { useState } from 'react'

import FilterLabel from './FilterLabel'
import { FilterWrapperProps } from './types'

export function FilterWrapper<
  T extends BeneficiaryFilterAllTypes,
  S extends StructuredDataSchemaItem,
>(props: FilterWrapperProps<T, S>) {
  const {
    schemaItem: { label },
    filter,
    optionalsCrushed,
  } = props

  const [open, setOpen] = useState(false)

  if (props.readonly)
    return (
      <Button variant="secondary" disabled className="font-normal disabled:opacity-70" size="sm">
        <FilterLabel label={label} filter={filter} optionalsCrushed={optionalsCrushed} />
      </Button>
    )
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="secondary" className="font-normal">
          <FilterLabel label={label} filter={filter} optionalsCrushed={optionalsCrushed} />
          <div
            className="text-primary-500 hover:text-primary scale-100 hover:scale-110 transition-all duration-300"
            onClick={() => props.onRemove(filter)}
          >
            <XIcon className="size-4" />
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full">{props.renderForm(() => setOpen(false))}</PopoverContent>
    </Popover>
  )
}
